interface FormHeaderProps {
  progress: number;
}

export function FormHeader({ progress }: FormHeaderProps): JSX.Element {
  return (
    <div className="re__optin--header">
      <span className="re__optin--header-text">
        Complete the survey to secure extra entries.
      </span>
      <div className="lander__quiz__header--progress-bar--container">
        <div className="progress-bar-container">
          <div
            className="progress-bar-indicator"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
